<template>
    <div class="answer answer-col account-item">
        <div class="row no-margin-bottom">
            <div class="col-md-4">
                <v-text-field
                        v-model="value.value"
                    label="How much monthly $" class="inputNumber"
                ></v-text-field>
            </div>
            <v-btn icon small class="account-delete" @click="$emit('delete', value)">
                <v-icon dark>mdi-delete</v-icon>
            </v-btn>
        </div>

        <div class="row">
            <div class="col-md-12">
                <p class="sub-question">
                    What is the source?
                </p>
                <div class="sub-answer answers-centered">
                    <span class="sub-alternative display-flex-grow-1" v-bind:class="{ active: value.name === 'Rental' }" @click="value.name = 'Rental'">Rental</span>
                    <span class="sub-alternative display-flex-grow-1" v-bind:class="{ active: value.name ==='Trust' }" @click="value.name = 'Trust'">Trust</span>
                    <span class="sub-alternative display-flex-grow-1" v-bind:class="{ active: value.name ==='Other' }" @click="value.name = 'Other'">Other</span>
                </div>
            </div>
        </div>

        <div class="row no-margin-bottom">
            <div class="col-md-12">
                <v-checkbox
                v-model="current"
                :label="`I am currently receiving it`"
                ></v-checkbox>
            </div>
        </div>

        <div class="row" v-if="!current">
            <div class="col-md-12">
                <label class="label-slider">I expect to start receiving this income when I am&nbsp;<span id="test-slider-4-text">{{ value.specific_age_to_start }}</span></label>
                <v-slider
                    v-model="value.specific_age_to_start"
                    class="align-center"
                    :max="100"
                    :min="min"
                    hide-details
                    track-color="#e0e0e0"
                >
                </v-slider>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'Income',
        props: [
            'value'
        ],
        data() {
            return {
                current: true,
            }
        },
        created() {
            if (this.value.start_year !== 0) {
                this.current = false;
            }
        },
        computed: {
            ...mapGetters('individuals', [
                'personOne',
                'personTwo',
            ]),
            min() {
                if (!this.value) {
                    return 0;
                }

                if (this.value.individual_id === this.personOne.id) {
                    return this.personOne.current_age;
                }

                return this.personTwo.current_age;
            }
        }
    }
</script>
